import component from "../../legacy/unavailable-alert"

export default component
